<div class="stepper-container w-500" [formGroup]="accidentDetailsForm">
  <div>
    <h3>Where are the assets (truck/trailer) located?</h3>
    <mat-form-field appearance="outline" class="column">
      <mat-label>Select Assets Located...</mat-label>
      <mat-select formControlName="assetsLocated">
        <mat-option *ngFor="let option of assetsOptions" [value]="option.id">
          {{ option.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <h3>Provide the type of crash</h3>
    <mat-form-field appearance="outline" class="column">
      <mat-label>Select Type of Crash...</mat-label>
      <mat-select formControlName="crashType">
        <mat-option *ngFor="let option of crashTypeOptions" [value]="option.id">
          {{ option.description }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div>
    <h3>Provide a description of the accident</h3>
    <mat-form-field appearance="outline" class="textarea w-full">
      <textarea matInput formControlName="accidentDescription"></textarea>
    </mat-form-field>
  </div>
  <div>
    <h3>Provide any witness information</h3>
    <mat-form-field appearance="outline" class="textarea w-full">
      <textarea matInput formControlName="witnessInfoDescription"></textarea>
    </mat-form-field>
  </div>
  <!-- TBD -->
  <div>
    <h3>Upload any images of the accident</h3>
    <!-- Drag & Drop and File Input -->
    <div
      class="upload-new-file-container"
      [ngClass]="{ 'file-present': imageUrls.length > 0 }"
    >
      <!-- Files Preview using app-attachments -->
      <app-attachments
        *ngIf="imageUrls.length > 0"
        [urls]="imageUrls"
        [fileNames]="imageFileNames"
        (deleteRequest)="removeImage($event)"
        [classicStyles]="true"
      ></app-attachments>

      <!-- Drag & Drop Area -->
      <div
        class="drag-drop-container"
        [ngClass]="{ 'no-border': imageUrls.length === 0 }"
        (click)="fileInput.click()"
        (drop)="onDrop($event)"
        (dragover)="onDragOver($event)"
      >
        <div class="icon-text-container">
          <input
            type="file"
            #fileInput
            multiple
            (change)="onFileSelected($event)"
            style="display: none"
            accept="image/*"
          />
          <i class="fa-solid fa-cloud-arrow-up"></i>
          <div class="drag-drop-text-container">
            <p *ngIf="imageUrls.length === 0" class="drag-drop-main-text">
              Drag & Drop Images
            </p>
            <p *ngIf="imageUrls.length > 0" class="drag-drop-main-text">
              Drag & Drop to Add More Images
            </p>
            <small class="drag-drop-secondary-text">or Select Files...</small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
